export default __webpack_public_path__ + "static/media/service.62423bd3.svg";